import useGlobalContext from "./useGlobalContext.js";
import { useCallback } from "react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import useTrackFlightsWebUseOfferPos from "./useTrackFlightsWebUseOfferPosExp.js";
import usePointOfSale from "./usePointOfSale.js";
import { pricingUtils } from "@flights/web-api-utils-universal";
import getRouteName from "../utils/getRouteName.js";
const useFormatPrice = (locale) => {
    const { ipCountry, locale: contextLocale } = useGlobalContext();
    const i18n = useI18n();
    const flightsWebUseOfferPosExp = useTrackFlightsWebUseOfferPos();
    let localeCountry = ipCountry;
    const routeName = getRouteName(window.location.pathname);
    const pointOfSale = usePointOfSale();
    const shouldFormatWithLocale = !routeName.includes("pb-") && routeName !== "confirmation";
    if (flightsWebUseOfferPosExp.isVariant && pointOfSale) {
        localeCountry = pointOfSale.toLowerCase();
    }
    const localeValue = shouldFormatWithLocale ? locale || contextLocale || "en-gb" : localeCountry || locale;
    const formatPrice = useCallback((price, options) => pricingUtils.formatPrice(price, localeValue, { ...options, useNativeFormatting: false }), [localeValue]);
    const formatAbbreviatedPrice = useCallback((price, preferredMaxLength) => pricingUtils.formatAbbreviatedPrice(price, localeValue, preferredMaxLength), [localeValue]);
    const priceOrFree = (price) => {
        return pricingUtils.priceIsZero(price) ? i18n.trans(t("flights_free_price")) : formatPrice(price);
    };
    const startingPrice = (price) => {
        return pricingUtils.priceIsZero(price)
            ? i18n.trans(t("flights_free_price"))
            : i18n.trans(t("flights_starting_price", { variables: { lowest_price: formatPrice(price) } }));
    };
    const plusPrice = (price, options) => {
        return pricingUtils.priceIsZero(price)
            ? i18n.trans(t("flights_free_price"))
            : i18n.trans(t("flights_ancillary_price_total", { variables: { total_price: formatPrice(price, options) } }));
    };
    return {
        priceToValue: pricingUtils.priceToValue,
        priceIsZero: pricingUtils.priceIsZero,
        formatPrice,
        priceOrFree,
        startingPrice,
        plusPrice,
        formatAbbreviatedPrice
    };
};
export default useFormatPrice;
